// import { upload } from '@testing-library/user-event/dist/upload';

import Expenses from "../../pages/expenses/Expenses";

export const ApiConstants = {
  Login: {
    login: 'api/system/login',
  },
  umb: {
    list: '/api/umb/list',
    listct: '/api/umb/listct',
    umbInvnetory: 'api/umb/umbInventory',
    closeInvoice: 'api/umb/closeInventoryInvoice',
    update: '/api/umb/update',
    approve: '/api/umb/approve',
    setCader: '/api/umb/update',
    delete: '/api/umb/delete',
    umb: '/api/umb',
    switch: 'api/umb/switch',
  },
  umbReservation: {
    availability: '/api/umb-reservation/availability',
    create: '/api/umb-reservation/create',
    update: '/api/umb-reservation/update',
    delete: '/api/umb-reservation/delete',
    listCt: '/api/umb-reservation/listct',
    byId: (id: number) => `/api/umb-reservation/getreservation?id=${id}`,
    checkIn: '/api/umb-reservation/check-in',
    cancel: '/api/umb-reservation/cancel',
    statusForDate: '/api/umb-reservation/status-for-date',
  },
  hotel: {
    hotels: '/api/hotel',
    dashboard: '/api/hotel/dashboard',
    hotelListCt: '/api/hotel/listct',
    hotelSave: '/api/hotel/save',
    hotelDelete: '/api/hotel/delete',
    hotelImageUpload: '/api/hotel/image',
    packages: '/api/hotel/packages',
    packageSave: '/api/hotel/packages/save',
    packageDelete: '/api/hotel/packages/delete',

    roomTypes: '/api/hotel/roomtypes',
    roomTypesListCt: '/api/hotel/roomtypes/listct',
    roomTypeSave: '/api/hotel/roomtypes/save',
    roomTypeDelete: '/api/hotel/roomtypes/delete',
    onlineRoomType: `/api/hotel/roomtypesbyhotel`,

    rooms: '/api/hotel/hotelmanagement',
    roomListCt: '/api/hotel/rooms/listct',
    roomSave: '/api/hotel/rooms/save',
    roomDelete: '/api/hotel/rooms/delete',
    availability: '/api/hotel/availability',
    reservations: '/api/hotel/rezervations',
  },
  publicHotel: {
    list: '/public/hotel/list',
    bySlug: '/api/public/hotel/by-slug',
    roomTypes: '/api/public/hotel/roomtypes',
    availability: '/api/public/hotel/availability',
    bookingRequest: '/api/public/hotel/booking-request',
    bookingRequests: '/api/public/hotel/booking-requests',
  },
  publicUser: {
    register: '/api/public/user/register',
    login: '/api/public/user/login',
    monitor: '/api/public/user/monitor',
    cancelBookingRequest: '/api/public/user/booking-request/cancel',
    forgotPassword: '/api/public/user/forgot-password',
    resetPassword: '/api/public/user/reset-password',
    profile: '/api/public/user/profile',
    changePassword: '/api/public/user/change-password',
    verifyActivation: '/api/public/user/verify-activation',
    resendActivation: '/api/public/user/resend-activation',
  },
  hotelPricing: {
    hotels: 'api/hotel',
    roomTypes: 'api/hotel/roomtypes',

    seasonPeriodList: '/api/hotel/season-period/listct',
    seasonPeriodSave: '/api/hotel/season-period',
    seasonPeriodDelete: '/api/hotel/season-period/delete',

    ratePlanList: '/api/hotel/rate-plan/listct',
    ratePlanSave: '/api/hotel/rate-plan',
    ratePlanDelete: '/api/hotel/rate-plan/delete',

    roomRateList: '/api/hotel/room-rate/listct',
    roomRateSave: '/api/hotel/room-rate',
    roomRateDelete: '/api/hotel/room-rate/delete',
  },
  reservation: {
    create: '/api/reservation/create',
    availability: '/api/reservation/availability',
    publicAvailability: '/api/reservation/public/availability',
    checkIn: `/api/reservation/checkin`,
    checkOut: `/api/reservation/checkout`,
    cancel: `/api/reservation/cancel`,
    listCt: '/api/reservation/listct',
    addPackage: '/api/reservation/package/add',
    listPackages: '/api/reservation/package/list',
    deletePackage: '/api/reservation/package/delete',
    updatePackage: '/api/reservation/package/update',
  },
  hotelFolio: {
    create: '/api/hotel-folio/create',
    byReservation: '/api/hotel-folio/by-reservation',
    rows: '/api/hotel-folio/rows',
    payments: '/api/hotel-folio/payments',
    paymentsByReservation: '/api/hotel-folio/payments/by-reservation',
    paymentHistory: '/api/hotel-folio/paymenthistory',
    saveRow: '/api/hotel-folio/rows/save',
    deleteRow: '/api/hotel-folio/rows',
    payment: '/api/hotel-folio/payment',
    balance: '/api/hotel-folio/balance',
    close: '/api/hotel-folio/close',
    closeOpenedByUser: '/api/hotel-folio/closeopenedbyuser',
    printInvoice: '/api/hotel-folio/print-invoice',
    printDailySummary: '/api/hotel-folio/print-daily-summary',
  },
  bookingRequest: {
    bookingRequestListCt: '/api/bookingrequest/listct',
    bookingRequestCreate: '/api/bookingrequest/create',
    bookingRequestUpdateStatus: '/api/bookingrequest/updatestatus',
    bookingRequestDelete: '/api/bookingrequest/delete',
    bookingRequestProfileList: '/api/bookingrequest/profile/list',
    bookingRequestCreateProfile: '/api/bookingrequest/profile/create',
    bookingRequestCreatePublic: '/api/bookingrequest/public/create',
  },
  bookingChannel: {
    overview: '/api/booking-channel',
    addAccount: '/api/booking-channel/account',
    updateAccount: (id: number) => `/api/booking-channel/account?id=${id}`,
    addPropertyMap: '/api/booking-channel/property-map',
  },
  User: {
    users: 'api/user/list',
    listCt: 'api/user/listct',
    update: 'api/user',
    delete: 'api/user/delete',
    changePassword: 'api/user/change-password',
    toggleCanPrintFiscal: 'api/user/toggle-can-print-fiscal',
    sendActivationOtp: 'api/user/send-activation-otp',
    activate: 'api/user/activate',
  },
  Roles: {
    list: 'api/utility/roles',
    update: 'api/utility/role/update',
    delete: 'api/utility/role/delete',
    grants: 'api/utility/role/grants',
    saveGrants: 'api/utility/role/grants',
    transfer: 'api/utility/role/transfer',
  },
  Company: {
    list: 'api/company/list',
    update: 'api/company/update',
    provision: 'api/company/provision',
    delete: 'api/company/delete',
  },
  companyEmailNotification: {
    list: '/api/company-email-notification/list',
    save: '/api/company-email-notification/save',
  },
  companyBalance: {
    report: '/api/company-balance/report',
  },

  expenses: {
    categories: {
      list: '/api/expense/category/list',
      listct: '/api/expense/category/listct',
      save: '/api/expense/category/save',
      delete: (id: number) => `/api/expense/category/delete?id=${id}`,
    },
    invoices: {
      list: '/api/expense/invoice/list',
      listct: '/api/expense/invoice/listct',
      byId: (id: number) => `/api/expense/invoice?id=${id}`,
      save: '/api/expense/invoice/save',
      delete: (id: number) => `/api/expense/invoice/delete?id=${id}`,
      summary: '/api/expense/invoice/summary',
    },
  },
  email: {
    send: '/api/email/send',
  },
  dailyInventoryClose: {
    previewUser: '/api/daily-inventory-close/preview-user',
    save: '/api/daily-inventory-close/save',
    byId: (id: number) => `/api/daily-inventory-close?id=${id}`,
    listCt: '/api/daily-inventory-close/listct',
    delete: (id: number) => `/api/daily-inventory-close/delete?id=${id}`,

  },
  dailyInventory: {
    list: '/api/daily-inventory/list',
    current: '/api/daily-inventory/current',
    byId: (id: number) => `/api/daily-inventory?id=${id}`,
    listCt: '/api/daily-inventory/listct',
    update: '/api/daily-inventory/update',
    delete: (id: number) => `/api/daily-inventory/delete?id=${id}`,
  },
  Currencies: {
    list: 'api/currencies/list',
    load: 'api/currencies/load',
    update: 'api/currencies/update',
  },
  integrations: {
    list: '/api/integrations',
    add: '/api/integrations',
  },
  integrationSettings: {
    companyOptions: '/api/integration-settings/company-options',
    byIntegrationId: (integrationId: number) => `/api/integration-settings/list?integrationId=${integrationId}`,
    add: '/api/integration-settings/add',
    edit: '/api/integration-settings/edit',
    upsert: '/api/integration-settings/upsert',
    saveAll: '/api/integration-settings/save-all',
  },

  area: {
    list: '/api/area/list',
    listct: '/api/area/listct',
    update: '/api/area/update',
    delete: '/api/area/delete',
  },
  playground: {
    list: '/api/playground/list',
    listct: '/api/playground/listct',
    update: '/api/playground/update',
    delete: '/api/playground/delete',
    inventory: '/api/playground/inventory',
    closeInvoice: '/api/playground/closeInventoryInvoice',
    activeSessions: (playgroundId: number) => `/api/playground/sessions/active?playgroundId=${playgroundId}`,
    startSession: '/api/playground/sessions/start',
    endSession: '/api/playground/sessions/end',
  },
  row: {
    list: '/api/row/list',
    listct: '/api/row/listct',
    update: '/api/row/Update',
    delete: '/api/row/delete',
  },
  invoiceTemp: {
    list: 'api/invoice/getListInvoiceTempByStatus',
    updateInvoicesTemp: 'api/invoice/updateInvoicesTemp',
    invoiceByTable: 'api/invoice/bytable',
    closeInvoice: 'api/invoice/close',
  },
  invoice: {
    list: 'api/invoice/list',
    listCt: 'api/invoice/listCt',
    subjects: '/api/invoice/subjects',
    openedbyuser: 'api/invoice/opened-by-user',
    closeAllOpenedByUser: 'api/invoice/close-opened-by-user',
    delete: '/api/invoice/delete',
    update: 'api/invoice/update',
    rows: 'api/invoice/rows',
    employeeList: '/api/invoice/employee/list',
    close: '/api/invoice/close',
    refiscalize: '/api/invoice/refiscalize',
    downloadPdf: '/api/invoice/download',
    filterByUser: '/api/invoice/filter-by-user',
    myUnpaid: '/api/invoice/user-invoice',
    updateAdminInvoice: 'api/invoice/updateadmininvoice',
    deleteRow: '/api/invoice/row',
  },

  Dashboard: {
    xxx: 'xxx',
    cards: 'api/utility/cards',
    graphs: 'api/utility/graphs',
    lastDayOrder: 'api/utility/lastDayOrder',
    cashBalanceList: 'api/utility/cash-balance/list',
    registerCashBalance: 'api/utility/cash-balance/register',
    serverHealth: 'api/server-health',
  },
  Products: {
    productCategory: 'api/product/productCategory',
    prodoductCategoryDelete: `api/product/productCategory/delete`,
    update: 'api/product/update',
    product: 'api/product',
    delete: 'api/product/delete',
    list: 'api/product/list',
    listct: 'api/product/listct',
  },
  productConfiguration: {
    byProduct: 'api/productConfiguration/byProduct',
    save: 'api/productConfiguration/save',
    disable: 'api/productConfiguration/disable',
  },
  feed: {
    posts: '/api/feed/posts',
    createPost: '/api/feed/posts/create',
    createComment: '/api/feed/comments',
    deletePosts: '/api/feed/coments/{id}',
    deleteComents: '/api/feed/posts/{id}',
    report: '/api/feed/report',
    like: '/api/feed/like',
  },
  tables: {
    tables: '/tavolinat',
    updateTable: '/updateTavolin',
    list: '/api/table/list',
    update: '/api/table/update',
    listCt: '/api/table/listCT',
    delete: '/api/table/delete',
    printInvoice: '/api/invoice/printInvoice',
  },
  productMenuDetails: {
    adminList: '/api/productMenuDetails/admin/list',
    byProduct: '/api/productMenuDetails/byProduct',
    upsert: '/api/productMenuDetails/upsert',
    delete: '/api/productMenuDetails/delete',
    menu: '/api/productMenuDetails/public/menu',
    menuByKey: '/api/productMenuDetails/public/menu',
  },
  order: {
    list: '/api/product/order/list',
    listct: '/api/product/order/listct',
    update: '/api/product/order',
    delete: '/api/product/delete',
    complete: '/api/product/order/complete',
  },
  stock: {
    list: '/api/product/stock/list',
    listct: '/api/product/stock/listct',
    update: '/api/product/stock',
    delete: '/api/product/delete',
  },
  print: {
    printerApp: '/api/print/printer-app',
  },
  file: {
    upload: 'api/upload/upload',
    download: 'api/upload/download',
    downloadById: 'api/upload/download/by-id',
    downloadByIdUrl: (id: number) => `/api/upload/download/by-id?id=${id}`,
    deleteById: (id: number) => `/api/upload/delete/by-id?id=${id}`,
    downloadUrl: (entityId: number, entityType: number, fileName?: string) =>
      `api/upload/download?entityId=${entityId}&entityType=${entityType}${fileName ? `&fileName=${encodeURIComponent(fileName)}` : ''}`,
    filesByEntity: (entityId: number, entityType: number) => `api/upload/files/by-entity?entityId=${entityId}&entityType=${entityType}`,
    metadataByEntity: 'api/upload/metadata/by-entity',
    metadataByEntityIds: 'api/upload/metadata/by-entity-ids',
  },

  utility: {
    uploadCT: 'api/utility/StoreTableCostumization',
    getResource: 'api/utility/resource',
    saveResource: 'api/utility/resource/save',

    printers: 'api/utility/printers',
    printersCreate: 'api/utility/printers',
    printersUpdate: 'api/utility/printers',
    printersDelete: 'api/utility/printers',
  },
  logger: {
    listCt: 'api/logger/listct',
    byId: (id: number) => `api/logger?id=${id}`,
  },
  notifications: {
    listCt: '/api/notification/listct',
    count: '/api/notification/count',
    read: (id: number) => `/api/notification/read?id=${id}`,
    readAll: '/api/notification/read-all',
    categories: {
      list: '/api/notification/category/list',
      listCt: '/api/notification/category/listct',
      save: '/api/notification/category/save',
      delete: (id: number) => `/api/notification/category/delete?id=${id}`,
    },
    userCategories: {
      list: '/api/notification/user-category/list',
      listCt: '/api/notification/user-category/listct',
      save: '/api/notification/user-category/save',
      delete: (id: number) => `/api/notification/user-category/delete?id=${id}`,
    },
  },
  enum: {
    allEnums: 'api/utility/allEnums',
  },
  EntityTypes: {
    Product: 1,
    User: 2,
    Row: 3,
    Table: 4,
    Hotel: 5,
    Company: 6,
    Post: 7,
    Category: 8,
    Tag: 9,
    Subject: 10,
    Invoice: 11,
    InvoiceRow: 12,
    ProductCategory: 13,
    ProductStock: 14,
    Order: 15,
    Room: 16,
    RoomType: 17,
    Reservation: 18,
    Guest: 19,
    BookingRequest: 20,
    Notification: 21,
    UMB: 22,
    Area: 23,
    DailyInventoryClose: 24,
    DailyInventory: 25,
    Expenses: 26,
    ExpenseCategory: 27,
    Playground: 28,
    PlaygroundSession: 29,
  },
};
